import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { WelcomeScreen } from './WelcomeScreen';
import { TemplateCurationScreen } from './TemplateCurationScreen';
import { OrientationScreen } from './OrientationScreen';
import { StepIndicator } from '../components/StepIndicator';
export function OnboardingFlow() {
  const [currentScreen, setCurrentScreen] = useState(1);
  const [direction, setDirection] = useState(1);
  const [activeStep, setActiveStep] = useState(0);
  const steps = ['Your Goal', 'Pick Template', 'Get Started'];
  const nextScreen = () => {
    setDirection(1);
    setCurrentScreen(prev => prev + 1);
  };
  const prevScreen = () => {
    setDirection(-1);
    setCurrentScreen(prev => prev - 1);
  };
  const handleTemplatePhaseChange = (phase: 'question' | 'results') => {
    if (phase === 'question') {
      setActiveStep(0);
    } else {
      setActiveStep(1);
    }
  };
  useEffect(() => {
    if (currentScreen === 3) {
      setActiveStep(2);
    } else if (currentScreen === 2 && activeStep === 2) {
      setActiveStep(1);
    }
  }, [currentScreen]);
  const variants = {
    enter: (direction: number) => ({
      x: direction > 0 ? 20 : -20,
      opacity: 0
    }),
    center: {
      zIndex: 1,
      x: 0,
      opacity: 1
    },
    exit: (direction: number) => ({
      zIndex: 0,
      x: direction < 0 ? 20 : -20,
      opacity: 0
    })
  };
  return <div className="w-full min-h-screen" data-id="element-108">
      <div className="bg-[var(--bg)] min-h-screen w-full text-[var(--text-primary)] font-sans selection:bg-[#ffc978]/30 flex flex-col" data-id="element-109">
        {/* Step Indicator - Only show after Welcome Screen */}
        <AnimatePresence data-id="element-110">
          {currentScreen > 1 && <motion.div initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} className="pt-4 z-30" data-id="element-111">
              <StepIndicator steps={steps} currentStep={activeStep} data-id="element-112" />
            </motion.div>}
        </AnimatePresence>

        <div className="flex-1 flex flex-col relative" data-id="element-113">
          <AnimatePresence mode="wait" custom={direction} data-id="element-114">
            {currentScreen === 1 && <motion.div key="screen1" custom={direction} variants={variants} initial="enter" animate="center" exit="exit" transition={{
            duration: 0.4
          }} className="w-full flex-1 flex flex-col" data-id="element-115">
                <WelcomeScreen onNext={nextScreen} data-id="element-116" />
              </motion.div>}

            {currentScreen === 2 && <motion.div key="screen2" custom={direction} variants={variants} initial="enter" animate="center" exit="exit" transition={{
            duration: 0.4
          }} className="w-full flex-1 flex flex-col" data-id="element-117">
                <TemplateCurationScreen onNext={nextScreen} onBack={prevScreen} onPhaseChange={handleTemplatePhaseChange} data-id="element-118" />
              </motion.div>}

            {currentScreen === 3 && <motion.div key="screen3" custom={direction} variants={variants} initial="enter" animate="center" exit="exit" transition={{
            duration: 0.4
          }} className="w-full flex-1 flex flex-col" data-id="element-119">
                <OrientationScreen onNext={() => alert('Flow Complete! Redirecting to editor...')} onBack={prevScreen} data-id="element-120" />
              </motion.div>}
          </AnimatePresence>
        </div>
      </div>
    </div>;
}